import {UI} from "../../stem-core/src/ui/UI";

import {styleRuleCustom, styleRuleInherit} from "../../stem-core/src/ui/UI";
import {Route, Router, TerminalRoute} from "../../stem-core/src/ui/Router";
import {GlobalStyleSheet} from "../GlobalStyleSheet";
import {iFrameBlinkService} from "../services/IFrameBlinkService";
import {IndexExpanded, isPopupPage} from "./pages/index-expanded/IndexExpanded";
import {IFrameMessages} from "../../blink-sdk/messaging/IFrameMessages";
import {iFrameConnection} from "../services/IFrameConnection";
import {styleRule} from "../../stem-core/src/decorators/Style";
import {Image} from "../../stem-core/src/ui/UIPrimitives";
import {iFrameState} from "../services/IFrameState";
import {WidgetRouting} from "./WidgetRouting";
import {authService} from "../../client/connection/Services";
import {WidgetCloseButton} from "./WidgetCloseButton";
import {WALLET_COLLAPSED_WIDTH, WIDGET_MAX_HEIGHT_MOBILE, WIDGET_TOGGLE_TRANSITION} from "./WidgetConstants";
import {AuthToken} from "../../client/connection/AuthToken";
import {widgetAnimation} from "./WidgetAnimation";
import {isSmallScreen} from "../UtilsLib";
import {PaywallApp} from "../paywall/PaywallApp";
import {unwrapArray} from "../../stem-core/src/base/Utils";
import {merchantStyleRule} from "../paywall/Security";
import {POPUP_GATE_TRANSITION_TIME} from "../../blink-sdk/Constants";
import {WidgetRoutes} from "./WidgetRoutes";
import {AuthService} from "../../client/connection/services/AuthService";
import {userService} from "../../client/connection/Services";
import {apiUpdateUserMerchantActivity} from "../../client/state/UserProfileStore";
import {iFrameMerchantService} from "../services/IframeMerchantService";
import {BasePanel} from "../paywall/pages/panels/BasePanel";


class WidgetGlobalStylesheet extends GlobalStyleSheet {
    @styleRuleCustom({selector: "body"})
    body = {
        userSelect: "text",
        pointerEvents: "none",
        ">*": {
            pointerEvents: "all",
        },
        maxHeight: () => isSmallScreen() ? WIDGET_MAX_HEIGHT_MOBILE : "",
        height: WALLET_COLLAPSED_WIDTH,
        margin: 0,
        fontFamily: this.themeProps.MERCHANT_FONT_FAMILY,
        " *": {
            userSelect: () => isSmallScreen() ? "none" : "auto",
            "-webkit-tap-highlight-color": "transparent",
        },
        ">div:nth-child(3)": {
            height: "100%",
        },
        ">div:nth-child(3)>:last-child": {
            minHeight: "100% !important",
            height: "100% !important",
        },
        position: "absolute",
        overflow: "hidden",
        // These are for Safari border bugs during animations.
        "-webkit-backface-visibility": "hidden",
        "-moz-backface-visibility": "hidden",
        "-webkit-transform": "translate3d(0, 0, 0)",
        "-moz-transform": "translate3d(0, 0, 0)",
        color: this.themeProps.MERCHANT_TEXT_PRIMARY_COLOR,
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_NORMAL,
        lineHeight: this.themeProps.GENERAL_LINE_HEIGHT,
    };

    @styleRuleInherit
    html = {
        userSelect: "none",
        fontSize: "10px",
        overflow: "hidden !important",
        width: "100%",
        height: "100%",
        transition: POPUP_GATE_TRANSITION_TIME + "ms background ease",
    };

    @styleRuleCustom({selector: "body>:first-child>div>div"})
    default5Child = {
        overflow: "hidden !important",
    };

    @styleRule
    visibleContainer = {
        ">:nth-child(2)": {
            transition: "none !important",
            opacity: 1,
        },
        ">:nth-child(2)>*": {
            opacity: 1,
        },
        ">:nth-child(3)": {
            transition: "none !important",
        },
    };

    @merchantStyleRule
    popupGate = {
        ">:first-child>:first-child": {
            opacity: 1,
            pointerEvents: "initial",
            boxSizing: "content-box",
            position: "fixed",
            top: 0,
            left: "50%",
            transform: "translateX(-50%)",
            margin: "auto",
            zIndex: 10500,
            overflow: "hidden",
            transition: POPUP_GATE_TRANSITION_TIME + "ms ease",
            transitionProperty: "width, height",
            borderRadius: this.themeProps.MERCHANT_FRAME_BORDER_RADIUS,
            ...iFrameState.gateStyle,
        }
    };

    @merchantStyleRule
    popupGateCustom = {
        ">:first-child>:first-child": {
            ...iFrameState.customGateStyle,
        }
    };

    @merchantStyleRule
    popupGateCancelButton = {
        ">:first-child>:last-child": {
            ...iFrameState.cancelButtonCustomStyle,
            " g": {
                fill: iFrameState.cancelButtonCustomStyle?.color || "",
            }
        }
    };

    @styleRuleInherit
    a = {
        fontWeight: this.themeProps.MERCHANT_FONT_WEIGHT_BOLD,
    };

    @styleRuleCustom({selector: "b"})
    b = {
        fontWeight: this.themeProps.MERCHANT_FONT_WEIGHT_BOLD,
    };

    @styleRuleInherit
    allInputs = {
        fontFamily: this.themeProps.MERCHANT_FONT_FAMILY,
    };
}

export class WidgetApp extends PaywallApp {
    appConstructor() {
        widgetAnimation.initListeners();
        iFrameConnection.addListener(IFrameMessages.REPOSITION_WIDGET, () => {
            if (!isPopupPage()) {
                widgetAnimation.repositionWidget();
            }
        });

        // Send merchant activity updates for a logged in user.
        this.sendMerchantActivity();
        WidgetRouting.initRoutesLogic();
        this.initRouter(WidgetRoutes.INDEX_COLLAPSED);
    }

    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        if (isPopupPage()) {
            attr.addClass(WidgetGlobalStylesheet.getInstance().popupGate);
        }
        if (this.router && this.router.getActive() instanceof BasePanel) {
            attr.addClass(WidgetGlobalStylesheet.getInstance().popupGateCustom);
            attr.addClass(WidgetGlobalStylesheet.getInstance().popupGateCancelButton);
        }
    }

    sendMerchantActivity() {
        let lastMerchantActivityToken = "";

        const updateMerchantActivity = () => {
            if (authService.isAuthenticated() && lastMerchantActivityToken !== authService.token.toString()) {
                apiUpdateUserMerchantActivity(iFrameMerchantService.merchantId);
                lastMerchantActivityToken = authService.token.toString();
            }
        };
        authService.addListener(AuthToken.EventTypes.LOGIN, updateMerchantActivity);
        iFrameState.addUpdateListener(updateMerchantActivity);
        updateMerchantActivity();
    }

    static initializeGlobalStyle() {
        WidgetGlobalStylesheet.initialize();
    }

    getRoutes() {
        if (this.routes) {
            return this.routes;
        }
        this.paywallRoutes = this.getSubroutes();
        this.routes = new Route([], null, [
            ...this.paywallRoutes,
            new TerminalRoute([], IndexExpanded, [], "")
        ]);

        return this.routes;
    }

    getContainer() {
        return (
            <div style={{height: "100%"}}>
                {this.getRouter()}
                {this.getStaticInvisibleElements()}
                {(isSmallScreen() || isPopupPage()) ? <WidgetCloseButton testId={isPopupPage() ? "modalCloseButton" : null}/> : <span/>}
            </div>
        );
    }

    // Render these invisible elements so the fetches execute earlier.
    getStaticInvisibleElements() {
        const merchant = iFrameMerchantService.getMerchant();

        // This is so that the elements are under no circumstance visible.
        return (
            <div style={{opacity: "0", pointerEvents: "none", zIndex: -1, position: "absolute", top: -1e4, left: -1e4}}>
                {merchant ? <Image src={merchant.wideLogoUrl} /> : null}
                <div style={{fontStyle: "italic"}}>a</div>
                <div style={{fontWeight: "bold"}}>a</div>
                <div>a</div>
            </div>
        );
    }

    applyWidgetPageStyle() {
        this.unapplyMerchantTheme();
        Object.assign(document.body.style, {
            overflow: "hidden",
            boxShadow: "",
            background: "transparent",
            opacity: 1,
            ...(iFrameState.widgetVisible ? {
                ...(widgetAnimation.collapsed ? {bottom: iFrameState.positionBottom + "px"} : {}),
                display: "initial",
            } : {
                display: "none",
            }),
        });

        if (widgetAnimation.collapsed) {
            Object.assign(document.documentElement.style, {
                background: "transparent",
            });
        } else {
            Object.assign(document.documentElement.style, {
                background: WidgetGlobalStylesheet.getInstance().themeProps.MERCHANT_SCRIM_BACKGROUND,
            });
        }
    }

    // TODO transform: "translate(50%,50%) makes the inner text blurry during animations
    applyPaywallPageStyle(hide=false) {
        this.applyMerchantTheme();
        this.applyMerchantMessages();

        const widgetVisible = authService.isAuthenticated() && iFrameState.widgetVisible;

        const {height, width, borderRadius} = iFrameState.gateStyle;
        const halfWidth = width ? parseInt(width, 10) / 2 + "px" : null;
        const halfHeight = height ? parseInt(height, 10) / 2 + "px" : null;
        const transform = `translate(${halfWidth || "50%"},${halfHeight || "50%"})`;
        Object.assign(document.body.style, {
            ...(height ? {height, maxHeight: height} : widgetVisible ? {} : {height: "", maxHeight: ""}),
            ...(width ? {width} : widgetVisible ? {} : {width: ""}),
            ...(borderRadius ? {borderRadius} : {}),
            ...(hide ? {
                transitionProperty: "opacity, border-radius",
                opacity: 0,
            } : {
                opacity: 1,
                transitionProperty: "width, height, transform, right, bottom",
            }),
            display: "initial",
            borderRadius: 0,
            right: "50%",
            bottom: "50%",
            transform,
        });

        if (hide) {
            Object.assign(document.documentElement.style, {
                background: "transparent",
            });
        } else {
            Object.assign(document.documentElement.style, {
                background: WidgetGlobalStylesheet.getInstance().themeProps.MERCHANT_SCRIM_BACKGROUND,
            });
        }
    }

    initRouter(initialPage) {
        authService.addListener(AuthService.EventTypes.CLEAR_CURRENT_INFO, () => {
            Router.changeURL(WidgetRoutes.INDEX_COLLAPSED);
        });

        const app = this;

        Router.useLocalHistory = true;
        Router.localHistory = [initialPage];
        Router.prototype.setActive = function(element) {
            if (this.activeChild === element) {
                return;
            }
            const oldActiveChild = this.activeChild;
            if (element) {
                this.activateChild(element);
            }
            if (oldActiveChild) {
                this.deactivateChild(oldActiveChild);
            }
            this.updateActiveChild(element);
        }
        let firstRouteChange = true;
        Router.prototype.setURL = function (url) {
            const urlParts = unwrapArray(url);
            const page = this.getPageToRender(urlParts);
            const activePage = this.getActive();

            if (activePage && activePage !== page) {
                activePage.dispatch("urlExit");
            }

            if (!page) {
                return;
            }

            // TODO: Check that the email does not remain set after a login-logout session
            if (activePage && isPopupPage(activePage) && !isPopupPage(page)) {
                app.paywallRoutes.forEach(route => route.clearCache());
            }

            if (firstRouteChange && "/" + urlParts[0] === WidgetRoutes.INDEX_COLLAPSED) {
                firstRouteChange = false;
            } else {
                Object.assign(document.body.style, {transition: WIDGET_TOGGLE_TRANSITION});
            }

            if (!isPopupPage(page)) {
                if (isPopupPage(activePage)) {
                    this.setActive(page);
                }
                this.setWidgetURL(url);
                if (!authService.isAuthenticated()) {
                    app.applyPaywallPageStyle(true);
                } else {
                    app.applyWidgetPageStyle();
                }
                return;
            }

            app.applyPaywallPageStyle();

            if (activePage !== page) {
                this.setActive(page);
                page.dispatch("urlEnter");
            } else {
                page.dispatch("urlReload");
            }

            iFrameConnection.sendToSDK(IFrameMessages.PAYWALL_CHANGE_ROUTE, {route: urlParts.join("/")});

            this.dispatch("change", urlParts, page, activePage);
        }
    }

    onMount() {
        super.onMount();

        iFrameBlinkService.init();

        const applyStyleChanges = () => {
            if (isPopupPage() || !authService.isAuthenticated()) {
                if (!isPopupPage()) {
                    this.applyPaywallPageStyle(true);
                } else {
                    this.applyPaywallPageStyle();
                }
            } else {
                this.applyWidgetPageStyle();
            }
        };
        iFrameState.addUpdateListener(applyStyleChanges);
        authService.onAuthenticationChange(applyStyleChanges);
        authService.onAuthenticationChange(() => {
            if (authService.isAuthenticated()) {
                userService.ensureUserDataRequested(() => IndexExpanded.instance.redraw());
            }
        });
    }
}
